var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2048,
    height: 2048,
    viewBox: "0 0 2048 2048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M816.666 1615.38C810.806 1610.16 807.137 1602.89 806.406 1595.04L748.159 970.286H955.451V1670.21C955.451 1696.9 924.212 1711.11 904.365 1693.44L816.666 1615.38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.451 957.888V870.675L737.099 851.654L747.003 957.888H955.451Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.451 858.231L735.929 839.109L701.618 471.087C699.923 452.905 714.11 437.193 732.224 437.193H924.71C941.688 437.193 955.451 451.07 955.451 468.187V858.231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.61 957.886H1518.62C1527.11 957.886 1533.99 950.948 1533.99 942.39V850.996C1533.99 841.842 1526.17 834.683 1517.13 835.573L1370.4 850.019L1360.61 957.886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.94 851.245L1139.28 872.772V957.886H1348.26L1357.94 851.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.99 873.982V957.886H544.755C536.266 957.886 529.385 950.948 529.385 942.39V850.791C529.385 841.711 537.092 834.577 546.065 835.351L1063.52 879.972C1064.45 880.052 1065.39 880.046 1066.32 879.955L1126.99 873.982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.91 1691.34C1172.6 1711.07 1139.28 1697.28 1139.28 1669.57V708.081H1371.22L1290.54 1580.56C1289.88 1587.68 1286.8 1594.36 1281.81 1599.45L1191.91 1691.34Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.37 695.683H1139.28V562.055L1386.16 546.527L1372.37 695.683Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.28 468.191V549.633L1387.32 534.033L1393.14 471.069C1394.82 452.894 1380.64 437.198 1362.54 437.198H1170.02C1153.05 437.198 1139.28 451.074 1139.28 468.191Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.452 695.684V562.444L708.876 550.21L722.366 695.684H955.452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.749 695.684H1589.33C1596.12 695.684 1601.62 690.133 1601.62 683.286V545.558C1601.62 538.402 1595.63 532.732 1588.55 533.186L1054.75 567.371L967.749 563.054V695.684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.455 549.544L710.184 695.684H461.14C454.349 695.684 448.844 690.133 448.844 683.286V550.33C448.844 543.244 454.725 537.599 461.744 537.947L695.455 549.544Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M814.195 1612.89C808.335 1607.67 804.666 1600.4 803.935 1592.56L745.688 967.799H952.981V1667.72C952.981 1694.42 921.741 1708.62 901.894 1690.96L814.195 1612.89Z",
    fill: "url(#paint0_linear_9954_165077)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M952.981 955.402V868.189L734.628 849.168L744.532 955.402H952.981Z",
    fill: "url(#paint1_linear_9954_165077)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M952.981 855.745L733.458 836.623L699.147 468.601C697.452 450.418 711.639 434.707 729.753 434.707H922.24C939.217 434.707 952.981 448.583 952.981 465.7V855.745Z",
    fill: "url(#paint2_linear_9954_165077)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1358.14 955.4H1516.15C1524.64 955.4 1531.52 948.462 1531.52 939.903V848.51C1531.52 839.356 1523.7 832.197 1514.66 833.086L1367.93 847.532L1358.14 955.4Z",
    fill: "url(#paint3_linear_9954_165077)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1355.47 848.759L1136.81 870.285V955.4H1345.79L1355.47 848.759Z",
    fill: "url(#paint4_linear_9954_165077)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.52 871.496V955.4H542.284C533.796 955.4 526.914 948.462 526.914 939.903V848.305C526.914 839.225 534.621 832.091 543.594 832.864L1061.05 877.485C1061.98 877.566 1062.92 877.56 1063.85 877.468L1124.52 871.496Z",
    fill: "url(#paint5_linear_9954_165077)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.44 1688.85C1170.13 1708.58 1136.81 1694.8 1136.81 1667.08V705.594H1368.75L1288.07 1578.07C1287.41 1585.2 1284.33 1591.87 1279.34 1596.96L1189.44 1688.85Z",
    fill: "url(#paint6_linear_9954_165077)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1369.9 693.197H1136.81V559.568L1383.69 544.041L1369.9 693.197Z",
    fill: "url(#paint7_linear_9954_165077)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.81 465.705V547.147L1384.85 531.547L1390.67 468.582C1392.35 450.407 1378.17 434.711 1360.06 434.711H1167.55C1150.57 434.711 1136.81 448.588 1136.81 465.705Z",
    fill: "url(#paint8_linear_9954_165077)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M952.982 693.198V559.958L706.405 547.723L719.896 693.198H952.982Z",
    fill: "url(#paint9_linear_9954_165077)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M965.278 693.198H1586.86C1593.65 693.198 1599.15 687.647 1599.15 680.8V543.072C1599.15 535.916 1593.16 530.246 1586.08 530.699L1052.27 564.885L965.278 560.568V693.198Z",
    fill: "url(#paint10_linear_9954_165077)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M692.985 547.057L707.713 693.198H458.669C451.878 693.198 446.373 687.647 446.373 680.8V547.843C446.373 540.757 452.254 535.113 459.274 535.461L692.985 547.057Z",
    fill: "url(#paint11_linear_9954_165077)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M744.72 837.604L733.458 836.623L720.087 693.198H719.896L706.405 547.723L706.525 547.729L699.147 468.601C697.452 450.418 711.639 434.707 729.753 434.707H922.24C933.897 434.707 944.039 441.249 949.25 450.89C944.888 448.494 939.885 447.133 934.568 447.133H742.082C723.967 447.133 709.78 462.844 711.476 481.027L718.853 560.155L718.733 560.149L732.224 705.624H732.415L744.72 837.604Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M965.31 693.198H977.606V572.994L1064.6 577.311L1598.41 543.125C1598.66 543.109 1598.91 543.101 1599.15 543.1V543.072C1599.15 535.916 1593.16 530.246 1586.08 530.699L1397.29 542.79L1397.18 543.973L1149.14 559.573V558.681L1052.27 564.885L965.309 560.57L965.31 693.198Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1387.07 450.889C1382.72 448.501 1377.73 447.137 1372.39 447.137H1179.88C1162.9 447.137 1149.14 461.014 1149.14 478.131V546.372L1136.81 547.147V465.705C1136.81 448.588 1150.57 434.711 1167.55 434.711H1360.06C1371.8 434.711 1381.88 441.303 1387.07 450.889Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.81 705.624H1368.75L1367.6 718.02H1149.14V1679.51C1149.14 1685.02 1150.46 1689.98 1152.72 1694.24C1143.55 1689.19 1136.81 1679.55 1136.81 1667.08V967.826H1136.84V883.922L1136.81 883.925V705.624Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.52 885.136V871.496L1063.85 877.468C1062.92 877.56 1061.98 877.566 1061.05 877.485L734.628 849.168L734.644 849.339L543.594 832.864C534.621 832.091 526.914 839.225 526.914 848.305V939.903C526.914 947.502 532.338 953.823 539.496 955.146C539.329 954.232 539.242 953.291 539.242 952.329V860.731C539.242 851.651 546.95 844.517 555.923 845.29L746.972 861.765L746.956 861.594L1073.38 889.911C1074.31 889.992 1075.25 889.986 1076.18 889.894L1124.52 885.136Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M745.691 967.826L803.935 1592.56C804.666 1600.4 808.335 1607.67 814.195 1612.89L821.185 1619.11C818.446 1614.91 816.737 1610.07 816.263 1604.98L758.016 980.226H952.981V967.828L745.691 967.826Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.24 955.4H1371.59L1380.25 859.958L1526.99 845.512C1528.46 845.368 1529.89 845.436 1531.27 845.691C1529.86 837.937 1522.74 832.29 1514.66 833.086L1369.12 847.415L1365.33 888.303L1359.24 955.4Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M694.181 558.931L692.985 547.057L459.274 535.461C452.254 535.113 446.373 540.757 446.373 547.843V680.8C446.373 687.647 451.878 693.198 458.669 693.198H458.701V560.269C458.701 553.183 464.582 547.539 471.602 547.887L694.181 558.931Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9954_165077",
    x1: 446.373,
    y1: 1066.74,
    x2: 1599.15,
    y2: 1066.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9954_165077",
    x1: 446.373,
    y1: 1066.74,
    x2: 1599.15,
    y2: 1066.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9954_165077",
    x1: 446.373,
    y1: 1066.74,
    x2: 1599.15,
    y2: 1066.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9954_165077",
    x1: 446.373,
    y1: 1066.74,
    x2: 1599.15,
    y2: 1066.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9954_165077",
    x1: 446.373,
    y1: 1066.74,
    x2: 1599.15,
    y2: 1066.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9954_165077",
    x1: 446.373,
    y1: 1066.74,
    x2: 1599.15,
    y2: 1066.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9954_165077",
    x1: 446.373,
    y1: 1066.74,
    x2: 1599.15,
    y2: 1066.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9954_165077",
    x1: 446.373,
    y1: 1066.74,
    x2: 1599.15,
    y2: 1066.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9954_165077",
    x1: 446.373,
    y1: 1066.74,
    x2: 1599.15,
    y2: 1066.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9954_165077",
    x1: 446.373,
    y1: 1066.74,
    x2: 1599.15,
    y2: 1066.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9954_165077",
    x1: 446.373,
    y1: 1066.74,
    x2: 1599.15,
    y2: 1066.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9954_165077",
    x1: 446.373,
    y1: 1066.74,
    x2: 1599.15,
    y2: 1066.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.7bd2e9146f075a08ffcdc8d81b9c2c0c.svg";
export { ForwardRef as ReactComponent };